import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { InboxState } from '../../../store/reducers/inbox.reducers';
import { DownloadFileCommand, ReplyPlatformMailCommand } from '../../../commands/inbox.command';
import { ReplyMessageModel, RecipientModel, FileAttachment } from '../../../models/inbox.model';
import { SaveReplyMailAction } from '../../../store/actions/inbox.actions';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import {map, startWith} from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { getAllRecepients } from '../../../store/selectors/inbox.selectors';
import { Subject } from 'rxjs';
import { FileDialogComponent } from '../../../../file-manager/component/file-dialog/file-dialog.component';
import { FileManagementService } from '@core/services/file-management.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { CommandService } from '@core/services/command.service';
@Component({
    standalone: false,
    selector: 'particle-reply-message',
  templateUrl: './reply-message.component.html',
  styleUrls: ['./reply-message.component.scss']
})
export class ReplyMessageComponent implements OnInit,OnDestroy {
  /*
   removePlugins: 'horizontalrule,tabletools,specialchar,about,list,others',
   removeButtons: 'Save,NewPage,Preview,Print,Templates,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Find,Select,Button,ImageButton,HiddenField,JustifyLeft,JustifyCenter,JustifyRight,JustifyBlock,CopyFormatting,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,PageBreak,Iframe,Font,FontSize,TextColor,BGColor,ShowBlocks,Cut,Copy,Paste,Table,Image,Format,Source,Maximize,Styles,Anchor,SpecialChar,PasteFromWord,PasteText,Scayt,Undo,Redo,Strike,RemoveFormat,Indent,Outdent,Blockquote,Underline'
   */
  inputForm: any;
  inputFormError: any;
  @Input() mailContent: any;
  unSubscribe$ = new Subject<void>();
  ckeditorContent:any;

  ckeConfig:any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  contactCtrl = new FormControl();
  contacts: any[] = [];
  allcontacts: any[]= [];
  allUsers :any[];
  filteredContacts: Observable<any[]>;
  @ViewChild('contactInput', {static: true}) contactInput: ElementRef;
  @ViewChild('auto', {static: true}) matAutocomplete: MatAutocomplete;

  replyMessageModel:ReplyMessageModel;
  @Output() discardMessage: EventEmitter<any> = new EventEmitter();
  constructor( private commandService: CommandService,private store: Store<InboxState>, protected snackBarService: SnackBarService,
              private formBuilder: FormBuilder,protected dialog: MatDialog,public fileManagementService:FileManagementService) {
    this.ckeConfig = {
      allowedContent: false,
      forcePasteAsPlainText: true,
      removePlugins: 'horizontalrule,tabletools,specialchar,about,list,others',
      removeButtons: 'Save,NewPage,Preview,Print,Templates,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Find,Select,Button,ImageButton,HiddenField,CopyFormatting,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,PageBreak,Iframe,Font,FontSize,TextColor,BGColor,ShowBlocks,Cut,Copy,Paste,Table,Image,Format,Source,Maximize,Styles,Anchor,SpecialChar,PasteFromWord,PasteText,Scayt,Strike,RemoveFormat,Blockquote,Subscript,Superscript,Link,Unlink,Indent,Outdent'
    };
    this.inputFormError = {
      replyMessage: {}
    };
    this.inputForm = this.formBuilder.group({
      replyMessage: ['',Validators.required]
    });

    this.filteredContacts = this.contactCtrl.valueChanges.pipe(
      startWith(null),
      map((contact: any | null) => {
       let res = contact ? this._filter(contact) : this.allcontacts.slice();
        return res;
      }
      ));

    this.replyMessageModel = new ReplyMessageModel();
    this.replyMessageModel.recipients = [];
    this.replyMessageModel.message = '';
  }
  remove(contact: any): void {
    this.contacts = this.contacts.filter(function( obj ) {
      return obj.email !== contact.email;
    });
  }
  add(event: MatChipInputEvent): void {
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      // Add
      if (value) {
        this.contacts.push(value);
      }

      // Reset the input value
      if (input) {
        input.value = '';
      }

      this.contactCtrl.setValue(null);
    }
  }
  selected(event: MatAutocompleteSelectedEvent): void {
    if(event.option.value.email){
      let alreadExists = this.contacts.find((x:any)=>{
        return x.email == event.option.value.email;
      });
      if(!alreadExists){
        this.contacts.push(event.option.value);
        this.contactInput.nativeElement.value = '';
        this.contactCtrl.setValue(null);
      }
    }

  }
   _filter(value: any): any[] {
    let filterValue:any;
    if(value.email){
      filterValue = value.email.toLowerCase();
    }
    else {
      filterValue = value.toLowerCase();
    }

    let res = this.allcontacts.filter(contact => {
      return (contact.firstName.toLowerCase().indexOf(filterValue) === 0) || (contact.email.toLowerCase().indexOf(filterValue) === 0);
    });
    return res;
  }
  ngOnInit() {
    this.replyMessageModel.fileAttachments = this.mailContent.fileAttachments;
    this.store.select(getAllRecepients).pipe(takeUntil(this.unSubscribe$)).subscribe((x:any)=>{
      if(x){
        this.allUsers =x;
        this.allcontacts =x;
        this.contacts = this.mailContent.recipients;
      }
    });
  }
  onFormValuesChanged() {
    for (const field in this.inputForm) {
      if (!this.inputForm.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormError[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormError[field] = control.errors;
      }
    }
  }
  reply(){
    this.replyMessageModel.message = this.ckeditorContent;
    this.replyMessageModel.recipients = this.contacts;
    this.replyMessageModel.mailThreadContentId =this.mailContent.id;
    const replyCommand = new ReplyPlatformMailCommand(this.replyMessageModel.message
      ,this.replyMessageModel.recipients,this.replyMessageModel.fileAttachments,this.mailContent.id);
    this.store.dispatch(new SaveReplyMailAction(replyCommand,this.mailContent.mailThreadId));

  }
  ngOnDestroy() {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
  downloadAttachment(attachment:any){
    this.executeDownloadFileCommand(attachment.attachmentId);
  }
  private executeDownloadFileCommand(fileEntryId: any) {
    const downloadFileCommand = new DownloadFileCommand(fileEntryId, '');
    this.commandService.executeCommand(downloadFileCommand).pipe().subscribe(data => {
      console.log('Download File', data);
      this.fileManagementService.downloadOneTimeSignedUrl(data.Payload['DownloadUrl'], data.Payload['FileName']);
    });
  }
  deleteAttachment(attachment:any){
      this.replyMessageModel.fileAttachments = this.replyMessageModel.fileAttachments.filter(function( obj ) {
      return obj.attachmentId !== attachment.attachmentId;
    });
  }
  showFileDialog() {

    const dialogRef = this.dialog.open(FileDialogComponent, {
      minWidth: '600px',
      maxWidth: '600px',
      data    : {
        itemsUrlIndex : 1,
        type          : 'SharedDrives',
        folderId      : '',
        driveId       : '',
        isFileSelector: true
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.unSubscribe$)).subscribe((result: any) => {
      if(result){
        let f = new FileAttachment();
        f.attachmentId = result.id;
        f.attachedDate = new Date();
        f.attachmentTitle = result.cells.Name.displayText;
        f.attachedBy = this.mailContent.createdBy;
        this.replyMessageModel.fileAttachments.push(f) ;
      }
    });
  }
  discard(){
    this.discardMessage.emit(true);
  }
  onChange(event){

  }
  onEditorChange(event){

  }
  onReady(event){

  }
  onFocus(event){

  }
  onBlur(event){

  }
  onContentDom(event){

  }
  onFileUploadRequest(event){

  }
  onFileUploadResponse(event){

  }
  onPaste(event){

  }
  onDrop(event){

  }
}
